import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6edcfa30&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6edcfa30&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=6edcfa30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edcfa30",
  null
  
)

export default component.exports